import styled from 'styled-components';
import { CircularProgressWithLabel } from '../Progress/CircularProgressWithLabel';
import DragDrop from '../ImageUploader/DragDrop';
import ExcelIcon from '../../assets/images/excel-icon.png';
import { Cross } from '../Icons';
import { Box, CircularProgress, Divider, IconButton } from '@mui/material';
import CustomButton from '../CustomButton/CustomButton';
import { formatBytes, truncateField } from '@src/helpers/Helpers';

const Container = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 658px;
	height: 155px;
	border: 1px dashed #ffbe00;
	background: #fff9e6;
	cursor: pointer;
	border-radius: 8px;
`;

type LoaderProps = { style?: React.CSSProperties; percentage: number };
export const UploadFileProgressLoader: React.FC<LoaderProps> = ({ style, percentage }) => {
	return (
		<Container style={style}>
			<CircularProgressWithLabel value={percentage} />
		</Container>
	);
};

const UploadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	@media screen and (max-width: 800px) {
		width: 100%;
	}
`;

const FileContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 1054px;
	height: 52px;
	border-radius: 6px;
	border: 1.5px solid #e9e9e9;
	margin-top: 14px;
	padding: 10px;
	@media screen and (max-width: 800px) {
		width: 95vw;
	}
`;

const FileInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
	#imgContainer {
		width: 32px;
		height: 32px;
		border-radius: 4px;
		border: 1.5px solid #e9e9e9;
		img {
			object-fit: contain;
		}
	}
	#name {
		display: flex;
		flex-direction: column;
		p {
			color: #333;
			font-size: 12px;
			font-weight: 600;
			height: 16px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		span {
			color: #acacac;
			font-size: 10px;
			font-weight: 600;
		}
	}
`;

interface UploadedProps {
	file: any;
	setFile: any;
	windowDimensions?: any;
}
export const Uploaded: React.FC<UploadedProps> = ({
	file,
	setFile,
	windowDimensions = null,
}) => {
	return (
		<UploadContainer>
			<FileContainer>
				<FileInfo>
					<div id="imgContainer">
						<img src={ExcelIcon} width="100%" height="100%" alt="file-icon" />
					</div>
					<div id="name">
						<p>
							{truncateField(
								file?.name,
								windowDimensions && windowDimensions?.width > 800 ? 40 : 35
							)}
						</p>
						<span>{formatBytes(file?.size)}</span>
					</div>
				</FileInfo>
				<IconButton onClick={() => setFile(null)}>
					<Cross />
				</IconButton>
			</FileContainer>
		</UploadContainer>
	);
};
